<script setup lang="ts">
import { useEmojiByChar } from '#shared'
import { computed } from 'vue'
import { useMessagePreview } from '#entities/message'
import type { AlertReaction } from '../model/alert'
import AlertContentLayout from './alert-content-layout.vue'

const emojiByChar = useEmojiByChar()

const { alert } = defineProps<{ alert: AlertReaction }>()

const emit = defineEmits<{ 'link-click': [] }>()

const message = computed(() => alert.message)
const messagePreview = useMessagePreview(message, 'small')

const emojiName = computed(() => {
  const char = alert.reaction?.char
  if (!char) return ''
  return emojiByChar.value.get(char)?.name ?? ''
})
</script>

<template>
  <AlertContentLayout v-if="alert.reaction" :alert="alert" @link-click="emit('link-click')">
    <template #label>added reaction {{ alert.reaction.char }} {{ emojiName }} to your message:</template>

    <template #content>
      {{ messagePreview }}
    </template>
  </AlertContentLayout>
</template>
